
// service imports
import { ArrecadacaoMensal, QtdDocumentosPorTipo, QtdDocumentosPorDia } from "services/CallAPIs"

export async function ChartDocsPorTipo()
{
    let tiposDoc = []
    let qtdsDoc = []
    const data = await QtdDocumentosPorTipo()

    let i = 0
    Object.entries(data).forEach(tipo => {
        
        if (1 <= tipo[1])
        {
            tiposDoc.push("" + i)
            qtdsDoc.push(tipo[1])
        }
        i += 1
    })

    console.log(Object.keys(tiposDoc))
    console.log(tiposDoc)
    // Object.keys(data).forEach(tipo => tiposDoc.push(tipo)) ["0", "1"]
    // Object.values(data).forEach(tipo => qtdsDoc.push(tipo))

    return {title: "Quantidade de documentos por tipo", labels: tiposDoc, values: qtdsDoc}
}

export async function ChartDocsPorDia()
{
    let dias = []
    let qtdsDoc = []
    const data = await QtdDocumentosPorDia(true)
    Object.keys(data).forEach(dia => dias.push(dia.substring(0, 2)))
    Object.values(data).forEach(qtdDocs => qtdsDoc.push(qtdDocs))

    return {title: "Quantidade de documentos por dia", labels: dias, values: Object.values(qtdsDoc)}
}

export async function ValorArrecadacaoMensal()
{
    return await ArrecadacaoMensal()
}